import { createSelector } from 'reselect'

import type { IAttentionOwnerAssignment } from '../../lib'

import { selectCockpitManagerUsers } from './selectCockpitManagerUsers'

/** Who manages each partner, for the attention tile's manager grouping. */
export const selectCockpitAttentionManagerAssignments = createSelector(
  [selectCockpitManagerUsers],
  (managerUsers): IAttentionOwnerAssignment[] =>
    managerUsers.map(({ PartnerId, Email, FullName }) => ({
      partnerId: PartnerId,
      ownerId: Email,
      ownerName: FullName || Email,
    }))
)
